"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/servicesSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "CLEANING" | "WHITENING" | "BRACES" */
    h20Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
};
export type HomeThreeServicesSectionGeneratedProps = {
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: ServicesSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    /** Default: "fade-up" */
    sectionDataAos?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-element-2.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    servicesSectionServicesSlides: ServicesSectionServicesSlidesItem[];
    servicesSectionServicesSlidesItemWrapper?: (item: ServicesSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    servicesSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesSlidesH2Visible?: boolean;
    servicesSectionServicesSlidesH2Renderer?: (item: ServicesSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: ServicesSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
};

const HomeThreeServicesSectionGenerated: FC<HomeThreeServicesSectionGeneratedProps> = ({
    sectionDataAos = "fade-up",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-element-2.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divH20H2Props,
    servicesSectionServicesSlides,
    servicesSectionServicesSlidesItemWrapper,
    servicesSectionServicesSlidesRenderer,
    servicesSectionServicesSlidesH2Visible,
    servicesSectionServicesSlidesH2Renderer,
    servicesSectionServicesSlidesH2Props,
}) => {
    return (
        <section className="slider-section slider-section-three position-relative aos" data-aos={sectionDataAos}>
            <div className="horizontal-slide slide-three d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        servicesSectionServicesSlides,
                        (item: ServicesSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(servicesSectionServicesSlidesH2Visible, servicesSectionServicesSlidesH2Renderer, item, (
                                    <h2 {...(typeof servicesSectionServicesSlidesH2Props === "function" ? servicesSectionServicesSlidesH2Props(item) : (servicesSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>{item.h20Text}</h2>
                                ))}
                            </div>
                        ),
                        servicesSectionServicesSlidesItemWrapper,
                        servicesSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-1 img-fluid" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThreeServicesSectionGenerated;
